import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { compose, withHandlers, withState } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { Modal } from '@material-ui/core';
import { connect } from 'react-redux';
import MenuBigButton from './atoms/MenuBigButton';
import MenuMidButton from './atoms/MenuMidButton';
import MenuSmallButton from './atoms/MenuSmallButton';
import MenuMidCustomButton from './atoms/MenuMidCustomButton';
import MenuLinkButton from './atoms/MenuLinkButton';
import ShopDownloadQr from '../containers/organisms/ShopDownloadQr';
import { getBookings } from '../actions/Booking';
import { getTextBySystem as gts } from '../utils';
import { nameSystem } from '../constants/TextSystem';

const styles = {
  root: {
    flexGrow: 1,
    backgroundColor: '#D8EBFF',
    padding: 10,
    paddingBottom: 0
  },
  paper: {
    padding: 5,
    textAlign: 'center',
    flex: '1 0 auto',
    margin: 5
  },
  itemBig: {
    width: 'calc(100% /5)',
    paddingRight: 3
  },
  width20: {
    width: '20%'
  },
  itemMid: {
    paddingRight: 3,
    paddingTop: 3
  },
  itemMidLast: {
    paddingTop: 3
  },
  itemSmall: {
    paddingRight: 3,
    paddingTop: 3
  },
  itemSmallLast: {
    paddingTop: 3
  },
  itemLink: {
    paddingRight: 3,
    paddingTop: 3,
    position: 'relative',
    '&::after': {
      content: '""',
      position: 'absolute',
      right: 0,
      top: 14,
      borderRight: '2px solid #A5A5A5',
      display: 'block',
      width: 1,
      height: 22
    }
  },
  itemLinkLast: {
    paddingTop: 3
  }
};

const enhance = compose(
  connect(
    state => ({
      listBookings: state.bookings.list.list
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getBookings
        },
        dispatch
      )
    })
  ),
  withState('openShopDownloadQr', 'setOpenShopDownloadQr', false),
  withState('countBookingNotice', 'setCountBookingNotice', ''),
  withHandlers({
    handleRedirect: props => path => {
      props.history.push(path);
    }
  })
);

const Main = enhance(
  ({
    classes,
    countBookingNotice,
    actions,
    setCountBookingNotice,
    handleRedirect,
    openShopDownloadQr,
    setOpenShopDownloadQr,
    account
  }) => {
    useEffect(() => {
      const searchKey = {
        status: 'WAITING'
      };
      actions.getBookings(searchKey).then(data => {
        if (data.type === 'GET_BOOKING_SUCCESS') {
          if (data.payload.list) {
            setCountBookingNotice(data.payload.list.length);
          }
        }
      });
    }, []);

    const openGochi = () => {
      handleRedirect('/gochis_shop');
    };
    const openBooking = () => {
      handleRedirect('/list_booking_shop');
    };
    const openPayment = () => {
      handleRedirect('/info_payments_shop');
    };
    const openShop = () => {
      handleRedirect('/shops_shop');
    };
    const openMenu = () => {
      handleRedirect('/gochi_menus_shop');
    };
    const openNotify = () => {
      handleRedirect('/notifications_shop');
    };
    // const openPost = () => {
    //   handleRedirect('/posts_shop');
    // };
    const openRegisStrip = () => {
      handleRedirect('/register_stripe_shop');
    };
    const openSetting = () => {
      handleRedirect('/settings_shop');
    };
    const openGochiKid = () => {
      handleRedirect('/gochi_kid_shop');
    };
    const openQrCode = () => {
      // handleRedirect('/download_qr_shop');
      setOpenShopDownloadQr(true);
    };
    const openPolicy = () => {
      const url = 'https://gochimeshi.com/policy/owner-terms/';
      window.open(url, '_blank');
    };
    const openChangeMail = () => {
      handleRedirect('/change_mail_shop');
    };
    const openChangePass = () => {
      handleRedirect('/change_pass_shop');
    };
    const openTicket = () => {
      handleRedirect('/tickets_shop');
    };
    const openGochiCode = () => {
      handleRedirect('/gochi_code_shop');
    };
    const openScanQrCode = () => {
      handleRedirect('/scan_qrcode_user');
    };

    const stripeStatus =
      account && account.accountStatus && account.accountStatus.stripeAccount;
    const disableRegisStripe = account && account.paymentGroupId;
    const isFukuoka =
      typeof account !== 'undefined' && account.fukuokaFlag === 1;
    const educateSystem =
      typeof account !== 'undefined' && account.educateSystem;
    const shopCategory = account && account.shopCategory;
    const shopGochiKidFlag = account && account.gochiKidFlag;
    return (
      <div className={classes.root}>
        <Grid container spacing={0}>
          <Grid item className={classes.itemBig}>
            <MenuBigButton
              classStyle={
                isFukuoka ? 'icon-fukuoka-gochi-shop' : 'icon-icon-gochi'
              }
              label={isFukuoka ? 'クーポン情報' : 'ごち情報'}
              onClickAction={openGochi}
            />
          </Grid>
          <Grid item className={classes.itemBig}>
            <MenuBigButton
              classStyle="icon-icon-payment"
              label={isFukuoka ? '精算情報' : '入金情報'}
              onClickAction={openPayment}
            />
          </Grid>
          <Grid item className={classes.itemBig}>
            <MenuBigButton
              classStyle="icon-icon-store"
              label={isFukuoka ? '教室情報' : '店舗情報'}
              onClickAction={openShop}
            />
          </Grid>
          <Grid item className={classes.itemBig}>
            <MenuBigButton
              classStyle="icon-icon-menu"
              label={isFukuoka ? 'コース登録' : 'メニュー情報'}
              onClickAction={openMenu}
            />
          </Grid>
          {!isFukuoka && (
            <>
              <Grid item className={classes.itemBig}>
                <MenuBigButton
                  classStyle="icon-booking"
                  numberCount={countBookingNotice}
                  label="お客様からの連絡"
                  onClickAction={openBooking}
                />
              </Grid>
              <Grid item xs={3} className={classes.itemMid}>
                <MenuMidButton
                  classStyle="icon-icon-info"
                  label="運営からのお知らせ"
                  onClickAction={openNotify}
                  // disabled
                />
              </Grid>
              {/* <Grid item xs={4} className={classes.itemMid}>
            <MenuMidButton
              classStyle="icon-icon-file"
              label="新着記事"
              onClickAction={openPost}
              // disabled
            />
          </Grid> */}
              <Grid item xs={3} className={classes.itemMid}>
                <MenuMidButton
                  classStyle="icon-icon-connection"
                  label={`Stripeに\n接続する`}
                  onClickAction={openRegisStrip}
                  stripeRegisteDone={stripeStatus}
                  disableRegisStripe={disableRegisStripe}
                />
              </Grid>
            </>
          )}
          {isFukuoka ? (
            <Grid item className={classes.itemBig}>
              <MenuBigButton
                classStyle="icon-icon-file"
                label={gts('紙/カード型クーポン消込', educateSystem)}
                onClickAction={openGochiCode}
                isFukuoka={isFukuoka}
              />
            </Grid>
          ) : (
            <Grid item xs={3} className={classes.itemMid}>
              <MenuMidButton
                classStyle="icon-icon-file"
                label="ごちコード消込"
                onClickAction={openGochiCode}
                // disabled
              />
            </Grid>
          )}
          <Grid item xs={isFukuoka ? 12 : 3} className={classes.itemMidLast}>
            <MenuMidButton
              disableRegisStripe={false}
              classStyle="icon-icon-qr"
              label={isFukuoka ? 'カード読取' : '会員証<br/>読込'}
              onClickAction={openScanQrCode}
              disableScanQrcodeUser={false}
              // disabled
            />
          </Grid>
          {!isFukuoka && (
            <>
              <Grid item xs={3} className={classes.itemMid}>
                <MenuMidCustomButton
                  classStyle="iconGochiKid"
                  label="こども<br/>ごちめし"
                  onClickAction={openGochiKid}
                  disableGochiKid={
                    process.env.REACT_APP_SHOW_GOCHI_KID === 'false' ||
                    process.env.REACT_APP_SHOW_GOCHI_KID === undefined ||
                    (shopCategory === 9 && shopGochiKidFlag === 0)
                  }
                />
              </Grid>
              <Grid item xs={3} className={classes.itemMid}>
                <MenuMidButton
                  classStyle="icon-icon-configuration"
                  label="設定"
                  onClickAction={openSetting}
                />
              </Grid>
              <Grid item xs={3} className={classes.itemMid}>
                <MenuMidButton
                  classStyle="icon-icon-qr"
                  label="QRコード発行"
                  onClickAction={openQrCode}
                />
              </Grid>
              <Grid item xs={3} className={classes.itemMidLast}>
                <MenuMidButton
                  classStyle="icon-icon-shop"
                  label="加盟店規約"
                  onClickAction={openPolicy}
                />
              </Grid>
            </>
          )}
          <Grid item xs={6} className={classes.itemLink}>
            <MenuLinkButton
              classStyle="icon-icon-email"
              label="メールアドレス変更"
              onClickAction={openChangeMail}
              disabled={
                isFukuoka && educateSystem && educateSystem !== nameSystem.suita
              }
            />
          </Grid>
          <Grid item xs={6} className={classes.itemLinkLast}>
            <MenuLinkButton
              classStyle="icon-icon-password"
              label="パスワード変更"
              onClickAction={openChangePass}
            />
          </Grid>
          <Grid
            item
            xs={6}
            className={classes.itemSmall}
            style={{ display: 'none' }}
          >
            <MenuSmallButton
              classStyle="icon-icon-configuration"
              label="List tickets"
              onClickAction={openTicket}
            />
          </Grid>
        </Grid>
        <div>
          <Modal open={openShopDownloadQr}>
            <ShopDownloadQr setOpenShopDownloadQr={setOpenShopDownloadQr} />
          </Modal>
        </div>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
